import { createApp } from "vue";
import App from "./App.vue";
import "./assets/style.css";
import PrimeVue from "primevue/config";

import "primevue/resources/themes/saga-blue/theme.css"; //theme
import "primevue/resources/primevue.min.css"; //core css
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "vue-loading-overlay/dist/vue-loading.css"; //Loading style

import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Card from "primevue/card";
import Image from "primevue/image";
import Divider from "primevue/divider";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import Paginator from 'primevue/paginator';
import Message from 'primevue/message';
import router from "./router";
import Loading from "vue-loading-overlay"; //component
import TheHeader from "./components/layouts/TheHeader.vue"
import TheSearchBar from "./components/layouts/TheSearchBar.vue"
import BaseButton from './components/common/BaseButton.vue'
import Tooltip from 'primevue/tooltip';
import mitt from 'mitt';
import ToastService from 'primevue/toastservice';

//createApp(App).mount('#app')

const emitter = mitt();
const app = createApp(App, {
    // Listen for the 'expand' event
    onExpand() {
      console.log('expand')
    }
  }).use(router);
app.component("Button", Button);
app.component("InputText", InputText);
app.component("Card", Card);
app.component("Image", Image);
app.component("Divider", Divider);
app.component("DataTable", DataTable);
app.component("Column", Column);
app.component("ColumnGroup", ColumnGroup);
app.component("Paginator", Paginator);
app.component("Message", Message);
app.component("Loading", Loading);
app.component("the-header", TheHeader);
app.component("the-search-bar", TheSearchBar);
app.component("base-button", BaseButton);
app.directive('tooltip', Tooltip);
app.component('Toast', ToastService);

app.use(PrimeVue);

app.config.globalProperties.emitter = emitter

app.mount("#app");
